function Loading() {
  return (
    <div className='w-full h-screen flex flex-col justify-center items-center'>
      <img src='/public/images/clap_show.svg' alt='logo' />
      <i className='mt-16 text-2xl text-primaryLight1 fa-solid fa-spinner animate-spin' />
    </div>
  )
}

export default Loading
